"use client";

import { api } from "@/lib/api-requests";
import { flattenText } from "@/lib/text";
import { Spinner } from "@heroui/spinner";
import { useEffect, useState } from "react";

export default function ContentBlock({language, contentKey, fallbackLanguage, format, className}: {language: string, contentKey: string, fallbackLanguage?: string | null, format: 'html' | null, className?: string}) {
    // Get the non-React translation cache from the window object, if available
    let windowContentCache: any = null;
    let cachedValue = null;

    if (typeof window !== "undefined") {
        windowContentCache = (window as any)._translationCache ?? {};
    }    
    
    if (windowContentCache != null) {
        cachedValue = windowContentCache[language]?.[contentKey];                
    }    

    const [content, setContent] = useState(cachedValue);
    const [contentError, setContentError] = useState(false);

    useEffect(() => {
        if (content == null && !contentError) {
            const load = async () => {
                const content = await api.getContentBlock(language, contentKey, fallbackLanguage ?? null, format);

                if (content != null) {                                                            
                    // Update the window translation cache
                    if (windowContentCache != null) {
                        windowContentCache[language] ??= {};
                        windowContentCache[language][contentKey] = content;
                    }

                    setContent(content);
                } else {
                    setContentError(true);
                }
            }

            load().catch(() => {
                setContentError(true);
            });
        }
    }, [contentKey, language, content, contentError]);

    if (content == null) {
        return null;
    }

    if (content.format == 'html') {
        return <div className={"formatted-html " + className} dangerouslySetInnerHTML={{ __html: content.content }} />;
    } else if (content.format == 'markdown' && format == 'html') {
        return <div className={"formatted-markdown " + className} dangerouslySetInnerHTML={{ __html: content.content }} />;
    } else if (content.format == 'markdown') {
        return content.content;
    } else {
        return content.content;
    }    
}